import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  SelectController,
  RangeController,
  ChoiceBoxController,
  CustomSortController,
  ToggleSwitchController,
} from '../../../controllers/Base';

const GeneralControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  forDrilldown = false,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      key="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0}
    >
      <SelectController
        label="Ordenar campos"
        handle={handle}
        kWord="SortValuesControl"
        // Alteracoes dos labels para arrumar inconsistências (Decidido dia 01/04/2026)
        options={[
          { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Alfabética Z-A', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
          { label: 'Alfabética A-Z', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
          { label: 'Valor Decrescente', value: 'Valor Crescente', id: 'valor-crescente' },
          { label: 'Valor Crescente', value: 'Valor Decrescente', id: 'valor-decrescente' },
          ...(forDrilldown ? [] : [{ label: 'Customizado', value: 'Customizado', id: 'customizado' }]),
        ]}
        configValue={config?.SortValuesControl}
        fullWidth
      />
      {config?.SortValuesControl === 'Customizado' && (
        <CustomSortController
          handle={handle}
          kWord="CustomSortControlUpt"
          oldOrder={data?.index || []}
          newOrder={config?.CustomSortControl?.kpiCategories || []}
          removeTotal
        />
      )}
      <ChoiceBoxController
        label="Formato"
        handle={handle}
        kWord="LayoutControl"
        configValue={config?.LayoutControl}
        options={[
          { label: 'horizontal', value: 'horizontal', id: 'horizontal' },
          { label: 'vertical', value: 'vertical', id: 'vertical' },
        ]}
        fullWidth
      />
      <ChoiceBoxController
        label="Interpolação"
        handle={handle}
        kWord="InterpolationControl"
        configValue={config?.InterpolationControl}
        options={[
          { label: 'Linear', value: 'linear', id: 'linear' },
          { label: 'Suave', value: 'smooth', id: 'smooth' },
        ]}
        fullWidth
      />
      <RangeController
        label="Tronco do Funil"
        handle={handle}
        kWord="BodyRadiusControl"
        configValue={config?.BodyRadiusControl?.value}
        min={0}
        max={1}
        step={0.1}
        precision={1}
        fullWidth
      />
      <RangeController
        label="Espaço entre as categorias"
        handle={handle}
        kWord="CategorySpacingControl"
        configValue={config?.CategorySpacingControl?.value}
        min={0}
        max={45}
        step={1}
        fullWidth
      />
      <RangeController
        label="Margem Superior"
        handle={handle}
        kWord="MarginTop"
        configValue={config?.Margin?.top}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Inferior"
        handle={handle}
        kWord="MarginBottom"
        configValue={config?.Margin?.bottom}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Esquerda"
        handle={handle}
        kWord="MarginLeft"
        configValue={config?.Margin?.left}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Direita"
        handle={handle}
        kWord="MarginRight"
        configValue={config?.Margin?.right}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <ChoiceBoxController
        label="Dados primários"
        handle={handle}
        kWord="DataFormat"
        configValue={config?.DataFormat}
        options={[
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormat === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormat"
          configValue={config?.DataAbsoluteFormat}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
          ]}
          fullWidth
        />
      )}

      <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />

      <ChoiceBoxController
        label="Dados secundários"
        handle={handle}
        kWord="DataFormatAlt"
        configValue={config?.DataFormatAlt}
        options={[
          { value: 'none', label: 'Nenhum', id: 'none' },
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormatAlt === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormatAlt"
          configValue={config?.DataAbsoluteFormatAlt}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
            { label: 'Variação', value: 'variation', id: 'variation' },
          ]}
          fullWidth
        />
      )}
      {config?.DataFormatAlt === 'percentual' && (
        <ChoiceBoxController
          label="Formato percentual"
          handle={handle}
          kWord="DataPercentFormatAlt"
          configValue={config?.DataPercentFormatAlt}
          options={[
            { label: 'Global', value: 'global', id: 'global' },
            { label: 'Variação', value: 'variation', id: 'variation' },
          ]}
          fullWidth
        />
      )}
      {(config?.DataPercentFormatAlt === 'variation' || config?.DataAbsoluteFormatAlt === 'variation') && (
        <>
          <span style={{ fontSize: '12px', color: 'gray' }}>
            *A variação é calculada de acordo com a ordenação.
            Caso invertida (seletor abaixo), será calculado do último para o primeiro.
          </span>
          <ToggleSwitchController
            label="Inverter direção da variação"
            handle={handle}
            kWord="InvertVariation"
            configValue={config?.InvertVariation}
            firstOption=""
            secondOption=""
            fullWidth
          />
        </>
      )}
      {(
        (config?.DataFormat === 'absolute' && config?.DataAbsoluteFormat === 'duration')
        || (config?.DataFormatAlt === 'absolute' && config?.DataAbsoluteFormatAlt === 'duration')
      ) && (
        <>
          <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />
          <ChoiceBoxController
            label="Unidade original"
            handle={handle}
            kWord="DurationUnit"
            configValue={config?.DurationUnit}
            options={[
              { label: 'Dias', value: 'days', id: 'days' },
              { label: 'Horas', value: 'hours', id: 'hours' },
              { label: 'Minutos', value: 'minutes', id: 'minutes' },
              { label: 'Segundos', value: 'seconds', id: 'seconds' },
            ]}
            fullWidth
          />
        </>
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  forDrilldown: PropTypes.bool,
};

export default GeneralControllers;
